import { TableViewStore, BaseListViewStore } from "core/stores";
import { ConfirmingReportService } from "application/confirming-report/services";
import { toDate } from 'core/utils';

class ConfirmingReportListViewStore extends BaseListViewStore {
	constructor(rootStore) {
		const confirmingReportService = new ConfirmingReportService(rootStore.application.baasic.apiClient);

		super(rootStore, {
			autoInit: true,
			name: 'confirming-report',
			routes: {
				confirmingReportPreview: item => {          
                    this.rootStore.routerStore.goTo(
                        'master.app.main.confirming-report.confirming-report-item.list',
                        { id: item.id, }
                    );
                },
				uploadReport: () => {
					this.rootStore.routerStore.goTo(
						"master.app.main.confirming-report.report-upload"
					);
				}
			},
			actions: () => {
				return {
					find: async params => {
						const response = await confirmingReportService.find({
							...params
						});

						return {
							...response.data,
							item: response.data.item.map(i => {
								return {
									...i,
									date: i.date && toDate(i.date)
								};
							})
						};
					}
				};
			},
		});

		this.setTableStore(
			new TableViewStore(this.queryUtility, {
				columns: [
					{
						key: 'filename',
						title: "CONFIRMING_REPORT.LIST.COLUMNS.FILE_NAME",
						onClick: item => this.routes.confirmingReportPreview(item)
					},
					{
						key: 'date',
						title: "CONFIRMING_REPORT.LIST.COLUMNS.DATE",
						onClick: item => this.routes.confirmingReportPreview(item)
					},
					{
						key: 'status',
						title: "CONFIRMING_REPORT.LIST.COLUMNS.STATUS",
						onClick: item => this.routes.confirmingReportPreview(item)
					},
					
				],
				actions: {
					onPreview: (item) => this.routes.confirmingReportPreview(item)
				},
			})
		);

	}

}

export default ConfirmingReportListViewStore;